<template>
  <el-aside
    class="leftSlide"
    style="width:auto"
    :class="collapse ? 'collapse' : 'notcollapse'"
  >
    <el-scrollbar style="height:100%;width:auto">
      <div class="slideTop flex fc255 fs26" style="padding: 0 20px">
        <i class="iconfont icon-shu mr10"></i>
        {{ !collapse ? '관리자' : '' }}
      </div>
      <el-menu
        router
        unique-opened
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        :collapse="collapse"
        background-color="#333744"
        text-color="#fff"
        active-text-color="#409EFF"
      >
        <el-menu-item index="/" v-if="role([1, 2, 3, 4])">
          <i class="iconfont icon-icon"></i>
          <span slot="title">{{ $t('tIndex') }}</span>
        </el-menu-item>
        <el-menu-item index="/carouselManagement" v-if="role([1])">
          <i class="iconfont icon-fuwu-active"></i>
          <span slot="title">{{ $t('tCarouselManagement') }}</span>
        </el-menu-item>
        <!-- <el-menu-item index="/memberManagement">
          <i class="iconfont icon-user"></i>
          <span slot="title">{{$t('tMemberManagement')}}</span>
        </el-menu-item> -->
        <el-submenu index="5" v-if="role([1])">
          <template slot="title">
            <i class="iconfont icon-user"></i>
            <span slot="title">{{ $t('tMemberManagement') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/memberManagement">{{
              $t('tMemberList')
            }}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/memberManagement/active">{{$t('tActiveMemberList')}}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/memberManagement/withdraw">{{$t('tWithdrawMemberList')}}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/memberManagement/disable">{{$t('tMemberDisable')}}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="adminUser.can_manage_sleep === 1">
            <el-menu-item index="/memberManagement/del">{{
              $t('tMemberDel')
            }}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="adminUser.can_manage_sleep === 1">
            <el-menu-item index="/memberManagement/dormant">{{
              $t('tDormant')
            }}</el-menu-item>
          </el-menu-item-group>
          <!-- <el-menu-item-group>
            <el-menu-item index="/memberManagement/send">{{
              $t('tSend')
            }}</el-menu-item>
          </el-menu-item-group> -->
        </el-submenu>
        <el-submenu index="4" v-if="role([1, 2])">
          <template slot="title">
            <i class="iconfont icon-shu1"></i>
            <span slot="title">{{ $t('tReadManagement') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/readManagement/readList">{{
              $t('tReadList')
            }}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/readManagement/read_userList">{{
              $t('tReadUserList')
            }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="/serialManagement/serialList" v-if="role([1, 4])">
          <i class="iconfont icon-bi"></i>
          <span slot="title">{{ $t('tSerialManagement') }}</span>
        </el-menu-item>
        <el-submenu index="3" v-if="role([1, 3])">
          <template slot="title">
            <i class="iconfont icon-campaign"></i>
            <span slot="title">{{ $t('tActivityManagement') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/activityManagement/activityList">{{
              $t('tActivityList')
            }}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/activityManagement/activity_userList">{{
              $t('tActivityUserList')
            }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="/orderManagement/orderList" v-if="role([1, 2])">
          <i class="iconfont icon-icon"></i>
          <span slot="title">{{ $t('tOrderManagement') }}</span>
        </el-menu-item>
        <el-menu-item index="/couponManagement/couponList" v-if="role([1, 2])">
          <i class="iconfont icon-youhuiquan"></i>
          <span slot="title">{{ $t('tCouponManagement') }}</span>
        </el-menu-item>
        <el-submenu index="1" v-if="role([1])">
          <template slot="title">
            <i class="iconfont icon-ai-article"></i>
            <span slot="title">{{ $t('tServiceManagement') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/serviceManagement/serviceCommentList">{{
              $t('tServiceCommentList')
            }}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/serviceManagement/serviceIntroduce">{{
              $t('tServiceIntroduce')
            }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!-- <el-menu-item index="/serviceCenter">
          <i class="iconfont icon-unie737"></i>
          <span slot="title">{{$t('tServiceCenter')}}</span>
        </el-menu-item> -->
        <el-submenu index="2" v-if="role([1, 2, 3])">
          <template slot="title">
            <i class="iconfont icon-unie737"></i>
            <span slot="title">{{ $t('tServiceCenter') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/serviceCenter/notice">{{
              $t('tNotice')
            }}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/serviceCenter/FAQ">{{
              $t('tFAQ')
            }}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/serviceCenter/QA">{{
              $t('tQA')
            }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="/setting" v-if="role([1])">
          <i class="iconfont icon-fuwu-active"></i>
          <span slot="title">{{ $t('tSetting') }}</span>
        </el-menu-item>
        <el-submenu index="6" v-if="role([1])">
          <template slot="title">
            <i class="iconfont icon-zhanghaoguanli"></i>
            <span slot="title">{{ $t('tAccountManagement') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/accountManagement">{{
              $t('tAccountManagement')
            }}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/accountManagement/ip">{{
              $t('tIP')
            }}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/accountManagement/log">{{
              $t('tLog')
            }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!-- <el-menu-item index="/accountManagement" v-if="role([1])">
          <i class="iconfont icon-zhanghaoguanli"></i>
          <span slot="title">{{$t('tAccountManagement')}}</span>
        </el-menu-item> -->
        <!-- <el-submenu index="2">
          <template slot="title">
            <i class="iconfont iconfuwu1"></i>
            <span slot="title">{{6}}</span>
          </template>
          <el-menu-item-group v-if="adminUser.auth===0">
            <el-menu-item index="/serviceManagement/serviceArea">{{7}}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="adminUser.auth===0">
            <el-menu-item index="/serviceManagement/serviceList">{{8}}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item
              index="/serviceManagement/serviceApplication"
            >{{9}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu> -->
      </el-menu>
    </el-scrollbar>
  </el-aside>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'leftSlide',
  props: ['collapse'],
  data() {
    return {
      routerList: [],
    };
  },
  methods: {
    role(arr) {
      return arr.includes(this.adminUser.auth);
    },
  },
  computed: {
    ...mapState(['adminUser']),
  },
  mounted() {
    this.routerList = this.$router.options.routes[0].children;
  },
  watch: {},
};
</script>
<style lang="scss">
.slideTop {
  height: 60px;
  i {
    font-size: 30px;
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 250px;
  min-height: 400px;
  i {
    margin-right: 10px;
  }
}
.el-menu-vertical-demo {
  i {
    font-size: 20px;
  }
}
.collapse {
  .el-scrollbar__bar {
    background: #333744;
    display: none;
  }
  .el-scrollbar__wrap {
    overflow: hidden;
    width: 63.5px !important;
    background: #333744;
    transition: all 0.3s ease-in-out;
  }
  width: 63.5px !important;
  transition: all 0.3s ease-in-out;
}
.collapse:not(.show) {
  display: block;
}
.notcollapse {
  .el-scrollbar__bar {
    display: none;
    background: #333744;
  }
  .el-scrollbar__wrap {
    overflow: hidden;
    width: 250px !important;
    background: #333744;
    transition: all 0.3s ease-in-out;
  }
  width: 250px !important;
  transition: all 0.3s ease-in-out;
}
.leftSlide {
  height: 100%;
  background: #333744;
  position: relative;
  overflow: hidden;
  .el-menu {
    border: none;
  }
}

.el-menu-item-group__title {
  display: none;
}
</style>
